import { useState } from 'react';
import {
    Row, Col, Table, Card, CardBody, CardHeader, Button, Input, Collapse,
    Badge, FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import './Lmu.css';
import { FaChevronUp, FaChevronDown, FaDrawPolygon, FaPlus } from 'react-icons/fa';
import uuid from 'react-uuid';
import Moment from 'moment';

const LmuChildItem = ({ item, topographyList, soilTypePredominantList, enterpriseTypeList, toggleChildItemState, hideChildren, handleEditItem, handleDeleteItem, 
     handleItemHighlight, handleChildItemToggle }) => {

    const [isOpen, setIsOpen] = useState(item.id == toggleChildItemState.lmuId ? toggleChildItemState.isOpen : false);
    const [isIconUp, setIsIconUp] = useState(item.id == toggleChildItemState.lmuId ? toggleChildItemState.isIconUp : false);
    const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });

    const handleItemExpandCollapse = (itemId) => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleChildItemToggle(itemId, !isOpen, !isIconUp)
    };

    const calculateSizeHa = (itemId) => {

        let size = item.lmuItems[0].sizeHa;
        return +size.toFixed(2);
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    if (item != undefined && item.isConnectedToAnotherLMU == true) {
        const ImagesCount = item.imageList != null ? item.imageList.length : 0;
         if ((hideChildren.lmuId == item.lmuId && hideChildren.ishideChildren == false)) {
            return (
                <>
                    {
                        <Card className="my-3" key={item.id}>
                            <CardHeader className="item-header item_click" onClick={(itemId) => handleItemExpandCollapse(item.id)}>
                                <Row>
                                    <Col sm="11">   <a onPointerEnter={(itemId) => handleItemHighlight(item.id)} onPointerLeave={(itemId) => handleItemHighlight(0)}>
                                        {item.mapMarkerType == 'polygon' && <FaDrawPolygon color={item.colour}></FaDrawPolygon>}
                                    </a>
                                        {' '}
                                        <span className="text-uppercase fw-bold color-dark-teal">{item.name}</span>{' - '} <span> {calculateSizeHa(item.id)}HA</span>{' '}
                                    </Col>
                                    <Col sm="1" className="toggleoutline">
                                        {
                                            isIconUp ?
                                                <FaChevronUp /> :
                                                <FaChevronDown />
                                        }
                                    </Col>
                                </Row>

                            </CardHeader>
                            <Collapse isOpen={isOpen}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <div>{item.description}</div><br />
                                            <div>Size(ha):
                                                {
                                                    <span> {calculateSizeHa(item.id)}</span>
                                                }
                                            </div>
                                            {/*<div>Enterprise: {*/}
                                            {/*    item?.lmuItems[0].isLUDoesNotHaveAnyFarmingOrGrowingActivities == true ? <span className="no-item-found-success">No Farming or Growing activities</span> : item?.lmuItems[0].enterpriseType != "" && item?.lmuItems[0].enterpriseType != "0" && item?.lmuItems[0].enterpriseType != null ? <span className="no-item-found-success">Not selected</span> : (enterpriseTypeList.find((e) => {*/}
                                            {/*        return e.id === item?.lmuItems[0].enterpriseType*/}
                                            {/*    }))?.value}</div>*/}
                                        </Col>
                                        <Col>
                                            <Button className="btn-items-actions" id={item.id} color="danger" size="sm" onClick={handleDeleteItem} >
                                                Archive
                                            </Button>
                                            <Button className="btn-items-actions" id={item.id} color="warning"  size="sm"  onClick={handleEditItem} >
                                                 Edit
                                            </Button>
                                        </Col>
                                    </Row>
                                    <br />
                                    {ImagesCount > 0 &&
                                        <Col sm="12">
                                            <Row>
                                                {item.imageList.map(image =>
                                                    <Col key={uuid()} sm="3" className="style-item-display">
                                                        <img src={image.imageRelativePath} className="image-thumbnail" alt={image.imageName} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, image.imageName, image.imageRelativePath)}></img>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Col>
                                    }

                                    {
                                        item.nonContiguousItems?.length > 0 ?
                                            <>
                                                <Row className="my-3">
                                                    <Col>
                                                        <h6>Non-contiguous LMU shapes</h6>
                                                        <Table bordered>
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        Title
                                                                    </th>
                                                                    <th>
                                                                        Size (ha)
                                                                    </th>
                                                                    <th>
                                                                        Topography
                                                                    </th>
                                                                    <th>
                                                                        Soil (predominant)
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="row">{item.name}</th>
                                                                    <td>{item.lmuItems[0].sizeHa}</td>
                                                                    <td>{(topographyList.find((topography) => {
                                                                        return topography.id === item?.lmuItems[0].topographyId && topography.id != 0
                                                                    }))?.value}</td>
                                                                    <td>{(soilTypePredominantList.find((soilType) => {
                                                                        return soilType.id === item?.lmuItems[0].soilTypePredominantId && soilType.id != 0
                                                                    }))?.value}</td>
                                                                </tr>
                                                                {
                                                                    item.nonContiguousItems.map(item =>
                                                                        <tr key={item.id}>
                                                                            <th scope="row">
                                                                                {item.name}
                                                                            </th>
                                                                            <td>
                                                                                {item?.lmuItems[0].sizeHa}
                                                                            </td>
                                                                            <td>
                                                                                {(topographyList.find((topography) => {
                                                                                    return topography.id === item?.lmuItems[0].topographyId && topography.id != 0
                                                                                }))?.value}
                                                                            </td>
                                                                            <td>
                                                                                {(soilTypePredominantList.find((soilType) => {
                                                                                    return soilType.id === item?.lmuItems[0].soilTypePredominantId && soilType.id != 0
                                                                                }))?.value}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </>
                                            : <></>
                                    }
                                </CardBody>
                            </Collapse>
                        </Card>

                    }

                    <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                        <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                        <ModalBody>
                            <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </>
            )
        }
    }
}

export default LmuChildItem